import { useTranslation } from "react-i18next";
const DashBoardCard=({card_image,card_title,card_subtitle,card_data})=>{
    const {t}=useTranslation();
    return(
        <>
            <div className="col-md-4">
                <div className="dbCard p-3 mb-4 d-flex flex-column justify-content-center card-shadow">
                    <span className="card-text mb-2">{card_title}</span>
                    <span className="card-subtext mb-2">{card_subtitle}</span>
                    <h4 className="card-data">{card_data}</h4>
                </div>
            </div>
        </>
    )
}

export default DashBoardCard;